import { ref, computed } from 'vue';
import postalCodesApi from '../../../api/postcodes-api';
const REQUEST_STATES = {
	INITIAL: 'INITIAL',
	LOADING: 'LOADING',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR'
};
export const useSettlements = () => {
	const settlements = ref([]);
	const requestState = ref(REQUEST_STATES.INITIAL);

	const getSettlementsByZip = async (zipCode) => {
		try {
			requestState.value = REQUEST_STATES.LOADING;
			const { data } = await postalCodesApi.getSettlements(zipCode);
			settlements.value = data.map((settlement) => settlement.settlement);
			requestState.value = REQUEST_STATES.INITIAL;
		} catch (err) {
			requestState.value = REQUEST_STATES.TECHNICAL_ERROR;
		}
	};

	const technicalError = computed(() => requestState.value == REQUEST_STATES.TECHNICAL_ERROR);

	return {
		getSettlementsByZip,
		settlements,
		technicalError
	};
};
